// services/pesapalService.js
// Central service for handling PesaPal payment-related API calls

const API_URL = process.env.REACT_APP_API_URL;
const API_TOKEN = process.env.REACT_APP_API_TOKEN;
const BASE_URL = process.env.REACT_APP_BASE_URL;

const headers = {
  'Content-Type': 'application/json',
  Authorization: `Bearer ${API_TOKEN}`,
};

export const PesapalService = {
  // Create an investment payment intent for investors
  createInvestment: async (investorId, projectId, amount, currency = 'KES', investmentId) => {
    console.log(amount, currency, investorId, projectId, investmentId, `${BASE_URL}/investor`);
    try {
      const response = await fetch(`${API_URL}/payments/investment`, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          amount,
          currency,
          investorId,
          projectId,
          investmentId,
          callbackUrl: `${BASE_URL}/investor`,
        }),
      });

      const data = await response.json();
      console.log({ data });

      if (!response.ok) {
        throw new Error(data.message || 'Failed to create investment intent');
      }

      return {
        data,
        error: null,
      };
    } catch (error) {
      console.error('Error creating investment intent:', error);
      return { data: null, error: error.message };
    }
  },
  // Create a deposit payment intent for borrowers
  createBorrowerDeposit: async (borrowerId, amount, currency = 'KES') => {
    console.log(amount, currency, borrowerId, `${BASE_URL}/borrower`);
    console.log({ API_URL });
    try {
      const response = await fetch(`${API_URL}/payments/deposit`, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          amount,
          currency,
          borrowerId,
          callbackUrl: `${BASE_URL}/borrower`,
        }),
      });

      const data = await response.json();
      console.log({ response });

      if (!response.ok) {
        throw new Error(data.message || 'Failed to create deposit intent');
      }

      return {
        data,
        error: null,
      };
    } catch (error) {
      console.error('Error creating borrower deposit intent:', error);
      return { data: null, error: error.message };
    }
  },
  // Verify a payment
  verifyPayment: async (orderTrackingId, transactionId) => {
    try {
      const response = await fetch(
        `${API_URL}/payments/verify?orderTrackingId=${orderTrackingId}&transactionId=${transactionId}`,
        {
          method: 'GET',
          headers,
        },
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to verify payment');
      }

      return {
        data,
        error: null,
      };
    } catch (error) {
      console.error('Error verifying payment:', error);
      return { data: null, error: error.message };
    }
  },
};
